import { dataorchApi } from './api';

export const getBrands = () => dataorchApi.get('/client-profiles/lists');
export const getBrand = (id) => dataorchApi.get(`/client-profiles/${id}`);
export const createBrand = (data) => dataorchApi.post('/client-profiles', data, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateBrand = (data) => dataorchApi.put('/client-profiles', data, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deleteBrand = (id) => dataorchApi.delete(`/client-profiles/${id}`);
